/**
 *
 * @param {function} fn 传入的回调函数
 * @param {number} interval 间隔时间
 * @param {*} options
 * leading 第一次是否执行
 * trailing 最后一次是否执行
 * resultCallback 回调函数返回值
 * @returns
 */
export function throttle(fn, interval, options = { leading: true, trailing: false, resultCallback: () => {} }) {
  let lastTime = 0
  let timer = null
  const { leading, trailing, resultCallback } = options

  function _throttle(...args) {
    const nowTime = new Date().getTime()

    // 默认刚开始不执行
    if (!lastTime && !leading) lastTime = nowTime

    const remainTime = interval - (nowTime - lastTime)
    if (remainTime <= 0) {
      if (timer) {
        clearTimeout(timer)
        timer = null
      }
      const result = fn.apply(this, args)
      if (resultCallback && typeof resultCallback === 'function') resultCallback(result)
      // 保留上次记录的时间
      lastTime = nowTime
      return
    }

    if (trailing && !timer) {
      timer = setTimeout(() => {
        timer = null
        // 避免后在执行一次 (核心就是在这里)
        lastTime = !leading ? 0 : new Date().getTime()
        const result = fn.apply(this, args)
        if (resultCallback && typeof resultCallback === 'function') resultCallback(result)
      }, remainTime)
    }
  }

  // 添加取消功能
  _throttle.cancel = function () {
    if (timer) clearTimeout(timer)
    timer = null
    lastTime = 0
  }

  return _throttle
}

/**
 *
 * @param {function} fn 回调函数
 * @param {number} delay 延迟时间
 * @param {boolean} immediate 是否立即执行
 * @param {function} resultCallback 获取返回值函数
 * @returns
 */
export function debounce(fn, delay = 500, immediate = false, resultCallback) {
  let timer = null
  let isInvoke = false
  function _debounce(...args) {
    if (immediate && !isInvoke) {
      const result = fn.apply(this, args)
      if (resultCallback && typeof resultCallback === 'function') resultCallback(result)
      isInvoke = true
    } else {
      if (timer) clearTimeout(timer)
      timer = setTimeout(() => {
        const result = fn.apply(this, args)
        if (resultCallback && typeof resultCallback === 'function') resultCallback(result)
        timer = null
        isInvoke = false
      }, delay)
    }
  }

  // 取消函数
  _debounce.cancel = function () {
    if (timer) clearTimeout(timer)
    timer = null
    isInvoke = false
  }

  return _debounce
}

export const guid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export function timeFormat(date, format = 'YYYY-MM-DD HH:mm:ss', isNormal = true) {
  if (isNormal) return dayjs(date).format(format)
  const formatTime = dayjs(date).format(format)
  const now = dayjs().format(format)

  const diffMinutes = dayjs(now).diff(formatTime, 'minute')
  const diffHours = dayjs(now).diff(formatTime, 'hour')
  const diffDays = dayjs(now).diff(formatTime, 'day')

  if (diffMinutes < 1) {
    return '刚刚'
  } else if (diffMinutes < 60) {
    return `${diffMinutes}分钟前`
  } else if (diffHours < 24) {
    return `${diffHours}小时前`
  } else if (diffDays < 2) {
    if (diffDays === 1) {
      return '昨天 ' + dayjs(date).format('HH:mm')
    } else {
      return '前天 ' + dayjs(date).format('HH:mm')
    }
  } else {
    return dayjs(date).format(format)
  }
}

export function stripHtml(html) {
  if (!html) return '';
  return html.replace(/<[^>]+>/g, '');
}

/**
 * 格式化数字，超过10000显示为x.x万
 * @param {number|string} num
 * @returns {string}
 */
export function formatNumber(num) {
  if (num === undefined || num === null || num === '') return '0'
  const n = Number(num)
  if (isNaN(n)) return '0'

  if (n < 10000) {
    return String(n)
  } else {
    // 保留一位小数，如果小数位是0则去掉
    return (n / 10000).toFixed(1).replace('.0', '') + '万'
  }
}

export function parseVal(value) {
  try {
    return JSON.parse(value)
  } catch (error) {
    return value
  }
}

export function findDetailContent(homeList, route, type) {
  // 其他配置
  if (route !== '/home') {
    const item = homeList.find(v => v.route === route)
    if (!item) return null
    const content = parseVal(item.content)
    return content // {imageUrl:''}
  }
  // 官网首页配置
  const item = homeList.find(v => v.route === '/home')
  if (!item) return null
  const content = parseVal(item.content)
  return content?.find(v => v.type === type)?.componentContent
}

export function findLevelListByName(list, name) {
  if (!Array.isArray(list) || !name) return null

  const dfs = currentList => {
    for (const item of currentList) {
      if (item?.name === name) return item
      if (Array.isArray(item?.children) && item.children.length > 0) {
        const found = dfs(item.children)
        if (found) return found
      }
    }
    return null
  }

  return dfs(list)
}
